import React, {memo, useState} from "react";
import {useTranslation} from "react-i18next";

import {useGlobalModalsContext} from "layouts/context/GlobalModalsProvider";
import {useAuthorization, useWindowSize} from "hooks";

import {GLOBAL_MODALS} from "utils";

import {WalletConnect} from "components/molecules";
import OptionsBlock from "./OptionsBlock";
import {Button} from "components/atoms";
import SwitchBlock from "./SwitchBlock";
import InfoBlock from "./InfoBlock";

import "./../style.scss"

const UserDetails = ({signOut, setMobileMenu}) => {
    const {t} = useTranslation()
    const {accessToken} = useAuthorization()
    const {setModal} = useGlobalModalsContext()
    const {width} = useWindowSize()

    const [isOpenUserMenu, setIsOpenUserMenu] = useState(false)

    return (
        <React.Fragment>
            {accessToken
                ? <div className="navigation_auth_user-details">
                    <div className="navigation_auth_user-details_panel">
                        <WalletConnect
                            setIsOpenUserMenu={() => width > 991 ? setIsOpenUserMenu(!isOpenUserMenu) : setMobileMenu({
                                open: true,
                                section: "userMenu"
                            })}/>
                        <SwitchBlock/>
                        <InfoBlock/>
                        <OptionsBlock
                            signOut={signOut}
                            setMobileMenu={setMobileMenu}
                            isOpenUserMenu={isOpenUserMenu}
                            setIsOpenUserMenu={setIsOpenUserMenu}
                        />
                    </div>
                </div>
                : <div className="navigation_auth_signIn-btn">
                    <Button
                        size="sm"
                        view="white"
                        onClick={() => setModal(GLOBAL_MODALS.SIGN_IN)}
                    >
                        {t("signInModalFormSignInButton")}
                    </Button>
                </div>}
        </React.Fragment>
    )
}

export default memo(UserDetails)